/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/views/layout/layout'

const employeeManageRouter = {
  path: '/employeeManage',
  component: Layout,
  hidden: false,
  redirect: 'noredirect',
  name: 'EmployeeManage',
  meta: {
    title: '员工管理',
    icon: 'employee',
    roles: ['admin']
  },
  children: [
    {
      path: 'employeeAccount',
      component: resolve => require(['@/views/manage/employeeManage/employeeAccount'], resolve),
      name: 'EmployeeAccount',
      meta: { title: '员工列表', noCache: false }
    },
    {
      path: 'rolePermission',
      component: resolve => require(['@/views/manage/employeeManage/rolePermission'], resolve),
      name: 'RolePermission',
      meta: { title: '角色权限管理', noCache: false }
    },
    {
      path: 'authority',
      component: resolve => require(['@/views/manage/employeeManage/authority'], resolve),
      name: 'Authority',
      meta: { title: '权限列表', noCache: false }
    }
  ]
}

export default employeeManageRouter



// WEBPACK FOOTER //
// ./src/router/manage/employeeManage.js